import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Alert } from "react-bootstrap";
import axios from 'axios';
import uploadImg from "../img/upload_icon.png";
import fileIcon from "../img/file_icon.png"
import delIcon from "../img/del_icon.png"


const MAX_COUNT=20;
const FILE_SIZE=20*1024*1024
let index=1

class ModalWRD extends Component {
  state = {
    error:"",
    uploadedFile:[],
    fileLimit:false,
    selectedOption:'Yes',
    showUploadModule:true,
    isFileUploaded:false,
    loading:false,
    last:false
  };

  handleClose =()=> {
    this.setState({uploadedFile:[]})
    this.setState({fileLimit:false})
    this.setState({selectedOption:'Yes'})
    this.setState({showUploadModule:true})
    this.setState({isFileUploaded:false})
    this.setState({loading:false})
    this.props.handleClose()
  }

  handleUploadFiles=(files)=>{
    const uploaded=[...this.state.uploadedFile]
    let limitExceeded=false
    let i=0
    files.some((file)=>{
      // console.log("File size",file.size)
      if(file.size>FILE_SIZE){
        alert("File size is greater than 20MB.")
      }
      else if(file.name.endsWith('.cpg') || file.name.endsWith('.dbf') || file.name.endsWith('.prj') || file.name.endsWith('.shp') || file.name.endsWith('.shx') || file.name.endsWith('.xml')){
        if(uploaded.findIndex((f)=>f.name===file.name)===-1){
          uploaded.push(file)
          if(uploaded.length===MAX_COUNT) this.setState({fileLimit:true})
          if(uploaded.length>MAX_COUNT){
            alert("You can only add a maximum of " +MAX_COUNT+ " files.")
            this.setState({fileLimit:true})
            limitExceeded=true
            return true
          }
        }
      }
      else{
        alert(file.name+" File type not allowed!")
        return false
      }
      
    })
    if(!limitExceeded) this.setState({uploadedFile:uploaded})
  }

  handleFileEvent=e=>{
    let n=0
    const chosenFiles=Array.prototype.slice.call(e.target.files)
    chosenFiles.map((file)=>{
      if(file.size>FILE_SIZE){
        n++
      }
    })
    if(n>0){
      alert("File size is greater than 20MB.")
    }
    else{
    this.handleUploadFiles(chosenFiles)
    }
  }

  deleteFile=(key)=>{
    let filteredArray = this.state.uploadedFile.filter(item => item.name !== key)
    this.setState({uploadedFile: filteredArray});
  }

  fileData = () => {   

        return (
          <div  style={{display:'flex', flexDirection:'row',justifyContent:'flex-start',flexWrap:'wrap'}}>         
          {this.state.uploadedFile.map(file=>
              <div key={index++} style={{display:'flex',flexDirection:'column',justifyContent:'flex-end',margin:10,borderRadius:20,backgroundColor:'#ffffff',boxShadow: '1px 1px 10px 1px #dddddd'}} title={file.name}>
                <img src={delIcon}  alt="del_icon" width={'30px'} height={'30px'} style={{alignSelf:'flex-end',padding:5,cursor:'pointer'}} onClick={event => this.deleteFile(file.name)}  />  
                <img src={fileIcon} alt="file" width={'50px'} height={'50px'} style={{alignSelf:'center',padding:5}}  />
                <span  style={{textAlign:'center',padding:10,}}>{file.name.substr(0,10)}</span>
                </div>      
           
          )} </div>
        );
};

handleEditWeights=()=>{
  this.setState({showUploadModule:true})
  this.props.handleNext()
}

onFileUpload = () => {
  if(this.state.uploadedFile.length<1){
    alert("Please select atleast one file to upload!")
  }
  else{
    this.setState({loading:true})
  const formData = new FormData();
  let i=0 
  this.state.uploadedFile.map(file=>{      
      formData.append(
        "myfile",
        file,
        file.name
    );
    // console.log("form",(formData))
  })
  
    // Details of the uploaded file
   
  
    // Request made to the backend api
    // Send formData object
    //axios.post('http://127.0.0.1:8000/polls', formData, {
    // axios.post('https://bhuvan-nyayavikas.nrsc.gov.in/GPSDP/upload', formData, {
      axios.post(this.props.baseURL+'/upload', formData, {
      method:'POST',
      headers: {
        'content-type': 'multipart/form-data',        
      }
    })
        .then(res => {          
          if(res.data=="Success"){
            this.setState({isFileUploaded:true})
            this.setState({loading:false})
            alert("Files are Uploaded Successfully.")           
          }
        })
        .catch(err => {
          this.setState({loading:false})
          alert("Some error occurred!")
          console.log(err)}) 
      }       

}
;

handleOptionChange=(changeEvent)=> {
  this.setState({
    selectedOption: changeEvent.target.value
  });
}

handleNxt=()=>{
  if(this.state.selectedOption=='Yes'){
    if(this.state.uploadedFile.length>0){
      if(this.state.isFileUploaded){
        // this.setState({selectedOption:''})
        this.setState({last:true})
        this.setState({showUploadModule:false})
        this.props.handleFileUpload()
      }
      else{alert("Please upload file")}
  }
    else{
      alert("Please select file to upload.")
    }
  }
  else{
    if(this.props.statecode==undefined || this.props.statecode==""){
      alert("Please Select State")
    } 
    else if(this.props.distcode==undefined || this.props.distcode==""){
      alert("Please Select District")
    } 
    else if(this.props.blockcode==undefined || this.props.blockcode==""){
      alert("Please Select Block")
    } 
    else if(this.props.gpcode==undefined || this.props.gpcode==""){
      alert("Please Select Gram Panchayat")
    }
    else {
      this.setState({showUploadModule:false})
      this.setState({last:true})
    }

  }
}

handleBack=()=>{
  this.setState({showUploadModule:true})
  this.setState({last:false})
}
  render() {
    return (
      <Modal
        show={this.props.showModal === "WRD"}
        size="xl"
        onHide={this.handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            WRD wizard: {this.props.ttitle[this.props.progressStep + 1]}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.props.progressStep === -1 && (
            <>
            {/*code added by adnan*/}

        
        <div style={{display:'flex',flexDirection:'column',justifyContent:'center',backgroundColor:'#ffffff',padding:10,borderRadius:30,margin:20,pointerEvents:this.state.loading?'none':''}} disabled={this.state.loading}>
              {this.state.showUploadModule ?
              <div>
              <h3>Do you want to upload Union & Drainage shape file?</h3>        
              <div style={{display:'flex',flexDirection:'row',justifyContent:'center',margin:10}}>
              <label>
                <input type="button" className="btn btn-secondary" value="Yes" style={{margin:10,width:150,alignSelf:'center',backgroundColor:this.state.selectedOption=='Yes'?'#0d6efd':'#ffffff',color:this.state.selectedOption=='Yes'?'#ffffff':'#000000'}}  onClick={this.handleOptionChange} />
                
              </label>   
            
              <label>
                <input type="button" value="No" style={{margin:10,width:150,alignSelf:'center',backgroundColor:this.state.selectedOption=='No'?'#0d6efd':'#ffffff',color:this.state.selectedOption=='No'?'#ffffff':'#000000',}} className="btn btn-secondary"  onClick={this.handleOptionChange} />
                
              </label>
              </div>


              {this.state.selectedOption=='Yes'?
             <div style={{display:'flex',flexDirection:'column'}}>
              <div style={{textAlign:'center',border: '3px dashed rgb(210, 227, 244)',position:'relative',borderRadius:30,width:'30%',alignSelf:'center'}}>
                      <img src={uploadImg} alt="upload" width={70} height={70}/>
                      <h5>Click to select files</h5>
                      <p style={{fontSize: '0.87rem', marginTop: '10px',color: '#bbcada'}}>Maximum {MAX_COUNT} files are allowed</p>
                      <p style={{fontSize: '0.87rem', marginTop: '10px',color: '#bbcada'}}>File size must be smaller than {(FILE_SIZE/(1024*1024))}MB</p>
                      <input accept=".cpg,.dbf,.prj,.shp,.shx,.xml" id="icon-button-file" 
                          type="file" style={{display: 'block', height: '100%', width: '100%', position: 'absolute', top: '0', bottom: '0', left: '0', right: '0', opacity: '0',cursor: 'pointer',}} onChange={this.handleFileEvent}  multiple={true} /> 
                        
              </div>        
                        
                        {this.fileData()}
              
                        <button type="button" className="btn btn-primary" style={{margin:10,width:150,alignSelf:'center'}} disabled={this.state.loading} onClick={this.onFileUpload}>{this.state.loading?'Uploading...':'Upload'}</button>
                        
          </div>
          
          :
          this.state.selectedOption=='No'?
          <div className="no-div">
            <select value={this.props.statecode} onChange={(e)=>this.props.fetchStates(e.target.value,"district")} className="dropdown-no-div" id="state_list">
              <option value="">Select State</option>             
              {this.props.states.map((item,i)=>
                <option value={item.stcode}>{item.stname}</option>
              )}
            </select>

            <select value={this.props.distcode} onChange={(e)=>this.props.fetchStates(e.target.value,"block")} className="dropdown-no-div" id="dist_list">
              <option value="" >Select District</option>
              {this.props.districts.map((item,i)=>
                <option value={item.dtcode}>{item.dtname}</option>
              )}
            </select>

            <select value={this.props.blockcode} onChange={(e)=>this.props.fetchStates(e.target.value,"gp")} className="dropdown-no-div" id="vill_list">
              <option value="" >Select Block</option>
              {this.props.blocks.map((item,i)=>
                <option value={item.bpcode}>{item.bpname}</option>
              )}
            </select>

            <select value={this.props.gpcode} onChange={(e)=>this.props.fetchStates(e.target.value,"gpcode")} className="dropdown-no-div" id="vill_list">
              <option value="" >Select Gram</option>
              {this.props.panchayats.map((item,i)=>
                <option value={item.gpcode}>{item.gpName}</option>
              )}
            </select>
            {this.props.loadingState?<div className="spinner-border" role="status" style={{alignSelf:'center',width:'30px',height:'30px',color:'#1d3e93'}}></div>:null}
          </div>:null}
          </div>
          :

          <div>
          <h3>Do you want to go with default weights?</h3>
                    <p>
                      In default weights wizard, we will use the default weights given
                      by experts. Still this program has capability to do analysis with
                      user defined custom weights. If you want to know more about the
                      different types of weights and importance of differnet layers.
                      Please click on <a href="www.google.com"> this link</a>.
                    </p>
                    <div style={{display:'flex',flexDirection:'row',justifyContent:'center',margin:10}}>
                        <Button variant="secondary" onClick={this.handleEditWeights} style={{margin:10,alignSelf:'center',backgroundColor:'#ffffff',color:'#000000'}}>
                          No, I want to edit default weights
                        </Button>
                        <Button variant="primary" onClick={this.props.handleDefaultWeights} style={{margin:10,alignSelf:'center',}}>
                          Yes, I want to go with default weights
                        </Button>
                      </div>
          </div>}             
        </div>

{/*code added by adnan*/} 
            </>
          )}

          {this.props.errorMessage && (
            <Alert key="danger" variant="danger">
              {this.props.errorMessage}
            </Alert>
          )}

          <div> </div>
          <table>
            <thead>
              <tr>{this.props.headerData[this.props.progressStep]}</tr>
            </thead>
            <tbody>
              {this.props.excelData[this.props.progressStep]?.map((row, i) => (
                <tr key={i}>
                  {Object.values(row).map((cell, j) => (
                    <td key={j}>
                      {j <= 1 && cell}
                      {j === 2 && cell.length > 5 && cell}
                      {j === 2 && this.props.progressStep !== 4 && (
                        <input
                          type="text"
                          size="8"
                          value={cell}
                          onChange={(e) => {
                            this.props.validateIt(
                              this.props.progressStep,
                              i,
                              j,
                              e.target.value
                            );
                            const newData = [...this.props.excelData];
                            newData[this.props.progressStep][i][
                              Object.keys(row)[j]
                            ] = e.target.value;
                            this.props.setExcelData(newData);
                          }}
                          disabled={!this.props.editData}
                        />
                      )}
                      {j >= 3 && (
                        <input
                          type="text"
                          size="8"
                          value={cell}
                          onChange={(e) => {
                            console.log(this.state.error);

                            this.props.validateIt(
                              this.props.progressStep,
                              i,
                              j,
                              e.target.value
                            );
                            console.log(this.state.error);
                            const newData = [...this.props.excelData];
                            newData[this.props.progressStep][i][
                              Object.keys(row)[j]
                            ] = e.target.value;
                            this.props.setExcelData(newData);
                          }}
                          disabled={!this.props.editData}
                        />
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
        {!this.state.last && (
        <Button variant="primary" onClick={this.handleNxt} disabled={this.state.loading}>
                          Next
        </Button>
          )}

        {this.state.showUploadModule==false && (
        <Button variant="secondary" onClick={this.handleBack} >
                          Back
        </Button>
          )}

        <Button variant="secondary" onClick={this.handleClose}>
            Close
          </Button>
         

          {this.props.progressStep >= 0 && (
            <Button variant="primary" onClick={this.props.handleEdit}>
              {!this.props.editData && "Edit"}
              {this.props.editData && "Close Edit"}
            </Button>
          )}
          {this.props.editData && this.props.progressStep >= 0 && (
            <Button variant="primary" onClick={this.props.handleReset}>
              Reset Table
            </Button>
          )}
          {this.props.progressStep >= 0 && (
            <Button variant="primary" onClick={this.props.handleNext}>
              {this.props.progressStep < this.props.maxSteps && "Next"}
              {this.props.progressStep === this.props.maxSteps && "Submit"}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ModalWRD;
